// src/components/chatbot-popover/chatbot-popover.tsx
import { Component, Prop, h, State, Event, EventEmitter } from "@stencil/core"

@Component({
  tag: "bot-popover",
  styleUrl: "bot-popover.css",
  shadow: true,
})
export class BotPopover {
  @Prop() popoverConfig: any
  @State() isBack = false
  @State() isVisible: boolean = false
  originalTitle: string
  flashInterval: any
  @Event({ eventName: "openChat", composed: true, cancelable: true, bubbles: true }) openChat: EventEmitter

  connectedCallback() {
    // console.log("popoverConfig", this.popoverConfig, this.isBack)
    const getVisitorKey = localStorage.getItem(`ai12z-visitorId`)
    const visitorID = "ai12z-" + getVisitorKey
    const storedMessages = localStorage.getItem(`${visitorID}`)
    let chatHistory = []
    if (storedMessages) {
      chatHistory = JSON.parse(storedMessages)
    }
    this.isBack = chatHistory.length > 0 ? true : false
  }

  componentDidLoad() {
    this.showPopoverAfterDelay()
  }

  flashTitle() {
    this.originalTitle = document.title // Store the original title
    let flashState = false

    // Flash the title by alternating the text
    this.flashInterval = setInterval(() => {
      document.title = flashState ? this.popoverConfig?.title : this.originalTitle
      flashState = !flashState
    }, this.popoverConfig?.delay) // Change every second (1 second flashing interval)
  }

  stopFlashingTitle() {
    clearInterval(this.flashInterval) // Stop flashing
    document.title = this.originalTitle // Restore the original title
  }

  showPopoverAfterDelay() {
    // Show the popover after the specified delay
    setTimeout(() => {
      this.isVisible = true
      this.flashTitle() // Flash the title
    }, this.popoverConfig?.delay)
  }

  showChat() {
    // Show the chat window
    this.isVisible = false
    this.openChat.emit("open")
    this.stopFlashingTitle() // Stop flashing the title
  }

  closePopover() {
    this.isVisible = false
    this.stopFlashingTitle() // Stop flashing the title
  }

  render() {
    return (
      <div class="popover-wrapper">
        {this.isVisible && (
          <div class="popover-content">
            <button class="popover-close" onClick={() => this.closePopover()}>
              ✕
            </button>

            <span innerHTML={this.isBack ? this.popoverConfig?.returnMessage : this.popoverConfig?.newMessage} onClick={() => this.showChat()}></span>
          </div>
        )}
      </div>
    )
  }
}
